import { FC, memo } from 'react';
import { Flex, Text } from '@chakra-ui/react';

import { Tooltip } from '~/core/shared/lib/chakraUi/components';
import { useDetailRow } from './hooks/useDetailRow';
import { DetailRowProps } from './types/DetailRowProps';

const DetailRowComponent: FC<DetailRowProps> = ({
  amount,
  highlight,
  label,
  bold,
  percent,
  tooltip,
}) => {
  const { fontWeight, value } = useDetailRow(amount, highlight, bold, percent);

  return (
    <Flex
      color={highlight ? 'primary.500' : undefined}
      fontSize="sm"
      fontWeight={fontWeight}
      justifyContent="space-between"
    >
      {/* a dd pairs with the dt before it by document order, the only
          relation the term and definition roles carry */}
      <Text as="dt">
        {tooltip ? (
          <Tooltip content={tooltip}>
            <Text as="span">{label}</Text>
          </Tooltip>
        ) : (
          label
        )}
      </Text>

      <Text as="dd">{value}</Text>
    </Flex>
  );
};

export const DetailRow = memo(DetailRowComponent);
